import { useEffect } from 'react';

const upsertMetaTag = (attrName, attrValue, content) => {
  if (typeof document === 'undefined') return;
  if (!attrValue || !content) return;

  let tag = document.head.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attrName, attrValue);
    tag.setAttribute('data-seo-managed', 'true');
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const upsertCanonical = (href) => {
  if (typeof document === 'undefined' || !href) return;

  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('data-seo-managed', 'true');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

const getAbsoluteUrl = (pathOrUrl) => {
  if (!pathOrUrl || typeof window === 'undefined') return '';
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return new URL(pathOrUrl, window.location.origin).toString();
};

const PublicPageSeo = ({ title, description, canonicalPath, ogImagePath = '/voiceralogo.png' }) => {
  useEffect(() => {
    if (typeof document === 'undefined' || typeof window === 'undefined') return;

    const canonicalUrl = getAbsoluteUrl(canonicalPath || window.location.pathname);
    const ogImageUrl = getAbsoluteUrl(ogImagePath);

    if (title) document.title = title;
    upsertMetaTag('name', 'description', description);
    upsertCanonical(canonicalUrl);

    upsertMetaTag('property', 'og:title', title);
    upsertMetaTag('property', 'og:description', description);
    upsertMetaTag('property', 'og:type', 'website');
    upsertMetaTag('property', 'og:url', canonicalUrl);
    upsertMetaTag('property', 'og:image', ogImageUrl);
  }, [title, description, canonicalPath, ogImagePath]);

  return null;
};

export default PublicPageSeo;
